function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed, observable, makeObservable } from "mobx";
import { BaseModel } from "../Models/Definition/Model";
/**
 * API for setting an access type for the model. Note that the intended use of
 * this mixin is just to flag public and private models differently in the UI
 * and does not provide any security guarantees.
 *
 * The implementation is a bit fluid and maybe that makes it a bit hard to
 * reason about because we are not strongly typing the possible values for
 * `accessType`. For use in frontend, we formally recognizes only one acessType
 * which is "public". All other access type values are treated as "private". The
 * models overriding this mixin are free to choose any other string valued
 * access type for their own purpose.
 */
function AccessControlMixin(Base) {
  var _class, _descriptor;
  let _AccessControlMixin = (_class = class _AccessControlMixin extends Base {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "_accessType", _descriptor, this);
      makeObservable(this);
    }
    get hasAccessControlMixin() {
      return true;
    }

    /**
     * Resolve accessType for this model in the following order:
     *  1. Return the access type that was set on this model by explicitly calling setAccessType()
     *  2. If this model is referenced by another, return the access type of the referrer
     *  3. Return the access type of a parent with valid access type
     *  4. If none of the above works - return "public"
     */
    get accessType() {
      // Return the explicitly set accessType
      if (this._accessType) {
        return this._accessType;
      }

      // Return the accessType of the referrer.
      if (AccessControlMixin.isMixedInto(this.sourceReference)) {
        return this.sourceReference.accessType;
      }

      // Try and return any ancestor's accessType
      if (this.knownContainerUniqueIds.length > 0) {
        const parentId = this.knownContainerUniqueIds[0];
        const parent = parentId && this.terria.getModelById(BaseModel, parentId);
        if (AccessControlMixin.isMixedInto(parent)) {
          return parent.accessType;
        }
      }

      // Default
      return "public";
    }
    setAccessType(accessType) {
      this._accessType = accessType;
    }

    /**
     * Returns true if this model public.
     */
    get isPublic() {
      return this.accessType === "public";
    }

    /**
     * Returns true if this model is private.
     *
     * Note that any accessType other than "public" is treated as private.
     */
    get isPrivate() {
      return this.accessType !== "public";
    }
  }, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_accessType", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "accessType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "accessType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAccessType", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAccessType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPublic", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPublic"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPrivate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPrivate"), _class.prototype), _class);
  return _AccessControlMixin;
}
(function (_AccessControlMixin3) {
  function isMixedInto(model) {
    return model && model.hasAccessControlMixin;
  }
  _AccessControlMixin3.isMixedInto = isMixedInto;
})(AccessControlMixin || (AccessControlMixin = {}));
export default AccessControlMixin;